<template>
	<div class="row position-relative">
		<div
			v-for="(field, index) in fields"
			:key="index"
			:class="[
				field.type == 'array' || colsNumber == 2
					? 'col-12'
					: 'col-lg-6 col-xxl-4',
			]"
			class="my-2"
		>
			<div v-if="!field.hide">
				<div v-if="field.type === 'array'">
					<div class="card mb-2 extract-container">
						<div class="card-header extract-header" style="height: 40px">
							<label
								><strong>{{ field.label == 'Extract' ? 'Edges to Extract' : field.label }}</strong></label
							>
						</div>
						<div
							v-for="(arrayField, arrayIndex) in yamlObj[field.name]"
							:key="arrayIndex"
							:class="[arrayIndex == 0 ? 'array-item-first' : 'array-item']"
						>
							<div
								:class="[arrayIndex == 0 ? 'collapsible-box-first' : '', 'collapsible-box']"
								v-if="arrayField"
							>
								<!-- Collapsible Header -->
								<div 
									:class="[arrayIndex == 0 ? 'pt-2 array-item-body-first' : 'array-item-body', 'collapsible-header']"
									@click="toggleCollapse(field.name, arrayIndex)"
								>
									<div class="header-content">
										<i 
											class="fa collapse-icon" 
											:class="isCollapsed(field.name, arrayIndex) ? 'fa-chevron-right' : 'fa-chevron-down'"
										></i>
										<span class="item-title">
											{{ field.name === 'extract' ? 'Edge' : removeLastS(field.label) }} 
											#{{ arrayIndex + 1 }}
										</span>
									</div>
									<button
										type="button"
										class="btn btn-sm btn-danger delete-btn"
										@click.stop.prevent="deleteArrayItem(field, arrayIndex)"
										:class="{ invisible: !editMode }"
										title="Delete item"
									>
										<i class="fa fa-trash"></i>
									</button>
								</div>
								
								<!-- Collapsible Content -->
								<div 
									class="collapsible-content" 
									:class="{ 'collapsed': isCollapsed(field.name, arrayIndex) }"
								>
									<div class="content-inner">
										<!--Recursive component-->
										<recursive-input-field
											:fields="field.arrayItems"
											:modelValue="yamlObj[field.name][arrayIndex]"
											:parentObj="yamlObj"
											:parentField="field.name"
											:parentIndex="arrayIndex"
											@update:modelValue="onUpdateParsedYaml"
											:editMode="editMode"
											:invalidValues="invalidValues"
											:entityTypeOptions="entityTypeOptions"
										></recursive-input-field>
									</div>
								</div>
							</div>
						</div>
						<div class="card-footer extract-footer">
							<button
								v-if="editMode"
								type="button"
								class="btn btn-sm btn-secondary float-end"
								@click="addArrayItem(field)"
							>
								<span v-if="field.name=='extract'"><i class="fa fa-plus"></i> Add {{ removeLastS('Edge') }}</span>
								<span v-else><i class="fa fa-plus"></i> Add {{ removeLastS(field.label) }} </span>
							</button>
						</div>
					</div>
				</div>
				<div v-else>
					<div v-if="!autYaml || (autYaml && !field.autHide)" class="ms-1">
						<div
							class="row mx-n1"
						>
							<div
								class="row mx-0"
								:style="{
									background: this.$store.state.darkMode ? 'linear-gradient(-135deg, #2e3238, #2e3238)' : 'linear-gradient(-135deg, #ced4da, #ced4da)',
									border: none,
									borderRadius: '5px 5px 0 0',
								}"
							>   
								<div class="col my-2 px-0 align-self-center">
									<strong>{{ field.label }}</strong>
								</div>
								<div class="col my-2 px-0 align-self-center">								
									<div
										class="btn-group float-end"
										v-if="editMode && getOptions(field).length"
									>
										<button
											type="button"
											class="btn-sm prop-btn dropdown-toggle"
											data-bs-toggle="dropdown"
											aria-expanded="false"
										>
											<i class="fa fa-plus mx-1"></i>
										</button>
										<ul class="dropdown-menu">
											<li
												v-for="option in getOptions(field)"
												:key="option.value"
												@click.prevent="
													addProperty(
														field,
														option.value,
														index
													)
												"
												:value="option.value"
											>
												<a class="dropdown-item" href="#">{{
													option.label
												}}</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div
								class="row mx-0"
								:style="{
									background: this.$store.state.darkMode ? 'linear-gradient(135deg, #1a1d23, #1a1d23)' : 'linear-gradient(135deg, #f5f5f5, #f5f5f5)',
									borderRadius: '0 0 5px 5px',
									border: this.$store.state.darkMode ? '1.5px solid #2e3238' : '1.5px solid #ced4da',
								}">
								<div v-if="!yamlObj[field.name]" :style="{height: '40px'}">
									<span class="no-data">No data found</span>
								</div>						
								<div
									class="col-12 my-2 px-0"
									v-for="(value, key, subIndex) in yamlObj[
										field.name
									]"
									:key="subIndex"
								>
									<div
										class="input-group"
										v-if="field.type.includes(key)"
									>
										<select
											class="w-25 form-select"
											:value="key"
											@change="
												updateSelect(
													field,
													$event.target.value
												)
											"
											:disabled="!editMode"
											style="max-width: 120px !important"
										>
											<option
												v-for="option in field.type"
												:key="option"
												:value="option"
											>
												{{ option }}
											</option>
										</select>
										<!-- Native input for all other fields -->
										<input
											v-if="(key == 'input' || key == 'const') && field.name !== 'entity_type' && field.name !== 'neighbor_type'"
											type="text"
											class="form-control w-50"
											:value="
												key == 'input'
													? value.source
													: value.value
											"
											@input="
												update(
													field,
													key,
													$event.target.value
												)
											"
											:disabled="!editMode"
										/>

										<!-- Custom component specifically for entity_type and neighbor_type -->
										<div v-if="field.name === 'entity_type' || field.name === 'neighbor_type'" class="flex-grow-1 form-group">
											<div v-if="key == 'input'">
												<MultiSelect 
													mode="single"
													:name="''"
													:options="entityTypeFieldOptions"
													:placeholder="'Enter/Select'" 
													:editable="editMode" 
													:modelValue="yamlObj[field.name][key].source"
													@update:modelValue="update(field, key, $event)"
													:createOption="true"
												/>
											</div>
											<div v-else-if="key == 'const'">
												<MultiSelect
													mode="single"
													:name="''"
													:options="entityTypeFieldOptions"
													:placeholder="'Enter/Select'" 
													:editable="editMode" 
													:modelValue="yamlObj[field.name][key].value"
													@update:modelValue="update(field, key, $event)"
													:createOption="true"
												/>
											</div>
										</div>

										<input
											v-if="key == 'list'"
											type="text"
											class="form-control w-50"
											:value="JSON.stringify(value.values)"
											@change="
												update(
													field,
													key,
													$event.target.value
												)
											"
											:disabled="!editMode"
										/>
										<!--Recursive component-->
										<recursive-input-field
											v-if="key == 'compound'"
											:fields="compoundFields"
											:modelValue="
												yamlObj[field.name]['compound']
											"
											:parentObj="yamlObj"
											colsNumber="2"
											:parentField="field.name"
											:parentIndex="key"
											@update:modelValue="onUpdateParsedYaml"
											:editMode="editMode"
											:invalidValues="invalidValues"
											:entityTypeOptions="entityTypeOptions"
										></recursive-input-field>
										<!-- <button type="button" class="btn btn-sm prop-btn"
											@click="deleteProperty(field, key)" v-if="editMode && !mapTypeKeys.includes(key)">
											<strong>-</strong>
										</button> -->
										<!--Recursive component-->
										<button
											type="button"
											class="btn btn-sm prop-btn"
											@click="deleteProperty(field, key)"
											v-if="editMode && ((field.optional) || (autYaml && field.autOptional))"
										>
											<strong>-</strong>
										</button>
									</div>								
									<div v-else-if="key == 'invalid_values'" class="">
										<div class="input-group d-flex justify-content-between align-items-center dark-mode-invalid-values" :style="{height: '40px', borderRadius: '0.2rem 0.2rem 0 0', backgroundColor: '#dee2e6'}">
											<div class="flex-grow-1">
												<span class="ms-3">{{ key }}</span>
											</div>
											<button
												type="button"
												class="btn btn-sm prop-btn" :style="{height: '40px', borderRadius: '0 0.2rem 0 0'}"
												@click="deleteProperty(field, key)"
												v-if="editMode"
											>
												<strong>-</strong>
											</button>
										</div>

										<div :style="{border: '2px solid #dee2e6', borderLeft: 'none', borderBottom: 'none', borderTop: 'none'}">
											<div
												v-for="(val, vIndex) in yamlObj[field.name]['invalid_values']" 
												:key="vIndex" 
												:class="[vIndex == 0 ? 'sub-array-item-first' : 'sub-array-item']"
											>
												<div :class="[vIndex == 0 ? 'pt-2 sub-array-item-body-first' : 'sub-array-item-body', 'pb-2']" :style="{paddingRight: '0.5rem', paddingLeft: '1.4rem'}">
													<div class="input-group ms-1">
														<input
															type="text"
															class="form-control form-control-sm code-font"
															:value="val" style="height: 30px; width: 80%"
															@input="updateInvalidValue(field, vIndex, $event.target.value)"
															:disabled="!editMode"
															:placeholder="val == null ? 'null' : 'invalid value'"
														/>
														<button
															v-if="editMode"
															type="button"
															class="btn btn-sm btn-outline-danger me-1" :style="{width: '25px'}"
															@click="removeInvalidValue(field, vIndex)"
														>

															<i class="fa fa-times align-items-center"></i>
														</button>
													</div>
												</div>
											</div>

											<div class="form-text alert-danger ps-1" v-if="errorObj[`${field.name}-${parentIndex}`]">
												{{ errorObj[`${field.name}-${parentIndex}`] }}
											</div>
										</div>

										<div class="sub-card-footer">
											<div class="d-flex justify-content-end">
												<button 
													v-if="editMode"
													type="button" 
													class="btn btn-sm btn-secondary"
													style="height: 30px; font-size: 0.7rem; padding: 0.5rem 0.5rem;"
													@click="addInvalidValue(field)"
												>
													<div class="d-flex align-items-center gap-1">
														<i class="fa fa-plus" style="font-size: 0.7rem;"></i>
														Add Value
													</div>
												</button>
											</div>
										</div>
									</div>
									<div v-else-if="key == 'to_lower'">
										<div class="input-group d-flex align-items-center" style="height: 40px;">
											<label
												class="input-group-text input-group-text2" :class="[!editMode ? 'bg-light' : '']"
												style="width: 120px; height: 100%; display: flex; align-items: center;"
												>to_lower</label
											>

											<div class="flex-grow-1 d-flex justify-content-center align-items-center" :class="[!editMode ? 'rounded-end' : '']" style="height: 100%; background-color: white; border: 1px solid #D2DDEC">
												<input
													type="checkbox"
													class="form-check-input"
													:checked="yamlObj[field.name]['to_lower']"
													@change="update(field, key, $event.target.checked)"
													:disabled="!editMode"
													style="transform: scale(1.3);"
												/>
											</div>
											
											<button
												type="button"
												class="btn btn-sm prop-btn"
												@click="deleteProperty(field, key)"
												v-if="editMode"
												style="height: 100%; border-radius: 0 0.2rem 0.2rem 0;"
											>
												<strong>-</strong>
											</button>
										</div>
									</div>
									<div v-else-if="key == 'trim_space'">
										<div class="input-group d-flex align-items-center" style="height: 40px;">
											<label
												class="input-group-text input-group-text2" :class="[!editMode ? 'bg-light' : '']"
												style="width: 120px; height: 100%; display: flex; align-items: center;"
											>
												trim_space
											</label>

											<div class="flex-grow-1 d-flex justify-content-center align-items-center" :class="[!editMode ? 'rounded-end' : '']" style="height: 100%; background-color: white; border: 1px solid #D2DDEC">
												<input
													type="checkbox"
													class="form-check-input m-0"
													:checked="yamlObj[field.name]['trim_space']"
													@change="update(field, key, $event.target.checked)"
													:disabled="!editMode"
													style="transform: scale(1.3);"
												/>
											</div>
											
											<button
												type="button"
												class="btn btn-sm prop-btn"
												@click="deleteProperty(field, key)"
												v-if="editMode"
												style="height: 100%; border-radius: 0 0.2rem 0.2rem 0;"
											>
												<strong>-</strong>
											</button>
										</div>
									</div>
									<div v-else-if="key == 'validate'">
										<div class="input-group">
											<label
												class="
													input-group-text
													input-group-text2
												"
												style="width: 120px"
												>validate</label
											>
											<input
												type="text"
												class="form-control w-25 flex-grow-1 code-font"
												:value="yamlObj[field.name]['validate']"
												disabled=true
											/>
											<button
												type="button"
												class="btn btn-sm prop-btn"
												@click="deleteProperty(field, key)"
												v-if="editMode"
											>
												<strong>-</strong>
											</button>
										</div>
									</div>
									<div v-else-if="key == 'map_value'">
										<div class="input-group">										
											<label
												class="
													input-group-text
													input-group-text2
												"
												style="width: 120px !important"
												>Map Value</label
											>
											<input
												type="text"
												class="form-control w-50 code-font"
												:value="
													JSON.stringify(
														yamlObj[field.name][
															'map_value'
														]
													)
												"
												@change="
													update(
														field,
														key,
														$event.target.value
													)
												"
												:disabled="!editMode"
											/>

											<button
												type="button"
												class="btn btn-sm prop-btn"
												@click="deleteProperty(field, key)"
												v-if="editMode"
											>
												<strong>-</strong>
											</button>
										</div>
										<div class="form-text alert-danger ps-1"  v-if="
											this.errorObj[
												`${field.name}-${parentIndex}`
											]
										">{{this.errorObj[
												`${field.name}-${parentIndex}`
											]}}
										</div>
									</div>
									<div v-else-if="field.type[0]=='map'">
										<div class="input-group">
											<input
												type="text"
												class="form-control w-25 code-font"
												:value="key"
												@change="
													updateMapKey(
														field,
														key,
														$event.target.value
													)
												"
												:disabled="!editMode"
											/>

											<select
												class="form-select w-25"
												:value="'const' in yamlObj[field.name][key]? 'const': 'input'"
												@change="updateInnerMapKey(field, key, $event.target.value)"
												:disabled="!editMode"
											>
												<option v-for="type in ['const', 'input']" :key="type" :value="type">
													{{ type }}
												</option>
											</select>

											<input
												type="text"
												class="form-control code-font  w-25"
												:value="'const' in yamlObj[field.name][key]?
													yamlObj[field.name][key]['const']['value']: 
													yamlObj[field.name][key]['input']['source']"
												
												@change="
													update(
														field,
														key,
														'const' in yamlObj[field.name][key]?
															{'const': {'value': $event.target.value}}:
															{'input': {'source': $event.target.value}}
													)
												"
												:disabled="!editMode"
											/>

											<button
												type="button"
												class="btn btn-sm prop-btn"
												@click="deleteProperty(field, key)"
												v-if="editMode"
											>
												<strong>-</strong>
											</button>
										</div>
										<div class="form-text alert-danger ps-1"  v-if="
											this.errorObj[
												`${field.name}-${parentIndex}`
											]
										">{{this.errorObj[
												`${field.name}-${parentIndex}`
											]}}
										</div>

									</div>
								</div>
								<div class="d-flex justify-content-end px-0 py-1">
									<button
										type="button"
										class="btn btn-sm btn-secondary" :style="{height: '30px', width: '98px', fontSize: '0.7rem', marginBottom: '0.3rem'}"
										@click="addProperty(field, 'map')"
										v-if="editMode && field.type[0] == 'map' && (this.yamlObj[field.name] != null && Object.keys(this.yamlObj[field.name]).length > 0)"
									>
										<span>
											<i class="fa fa-plus" style="font-size: 0.7rem;"></i>
											Add Entry
										</span>
									</button>
								</div>
								<div
									class="col-12"
									v-if="
										this.addNewPropFlagObj[
											`${field.name}-${index}`
										]
									"
								>
									<select
										class="form-select w-50 prop-btn btn-sm"
										v-if="
											editMode &&
											this.addNewPropFlagObj[
												`${field.name}-${index}`
											]
										"
										value="default"
										@input="
											addProperty(
												field,
												$event.target.value,
												index
											)
										"
									>
										<option selected value="default">
											Select Property To Add
										</option>
										<option
											v-for="option in getOptions(field)"
											:key="option.value"
											:value="option.value"
										>
											{{ option.label }}
										</option>
									</select>
								</div>
							</div>
						</div>
					</div>
					<!-- Delete properties with autHide false if yaml is aut type Ex entity_id and neighbour_id-->
					<div v-else>{{ deleteProperty(field, null) }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Fields from "../utils/field-constants/idrEdgeCompoundFields";
	import MultiSelect from "./MultiSelect.vue";
	export default {
		name: "recursive-input-field",
		components: { MultiSelect },
		data() {
			return {
				compoundFields: Fields,
				addNewPropFlagObj: {},
				errorObj: {},
				mapTypeKeys: ["const", "input", "compound", "list", "map"],
				collapsedState: {}, // Track collapse state for each array item

				// entityTypeFieldOptions - refined options with entityTypeOptions + current holding value
				entityTypeFieldOptions: [],
			};
		},
		computed: {
			yamlObj() {
				return this.modelValue;
			},
			autYaml() {
				if(this.parentObj)
					return this.hasNestedKey(this.parentObj,"compound");
				else
					return this.hasNestedKey(this.modelValue,"compound");
			},
			mapPropKeys() {
				return this.autYaml? ["invalid_values", "to_lower", "validate", "trim_space"]: ["invalid_values", "map_value", "to_lower", "validate", "trim_space"];
			}
		},
		props: {
			fields: Array,
			modelValue: {
				type: Object,
				default: () => {},
			},
			editMode: {
				type: Boolean,
				default: true,
			},
			parentField: {
				type: String,
				default: null,
			},
			parentObj: {
				type: Object,
				default: null,
			},
			parentIndex: {
				type: Number,
				default: null,
			},
			colsNumber: {
				type: Number,
				default: 3,
			},
			invalidValues: {
				type: Array,
				default: () => [],
			},
			entityTypeOptions: {
				type: Set,
				default: () => new Set(),
			},
		},
		watch: {
			editMode(val) {
				this.errorObj = {};
			},
			entityTypeOptions: {
				handler(val) {
					this.updateEntityTypeOptions();
				},
				deep: true
			}
		},
		beforeMount() {
			// console.log("yamlObj: ", this.yamlObj);
			this.updateEntityTypeOptions();
		},
		methods: {
			updateEntityTypeOptions() {
				if (this.yamlObj && (Object.hasOwn(this.yamlObj, "entity_type") || Object.hasOwn(this.yamlObj, "neighbor_type"))) {
					let currentValue = this.yamlObj.entity_type?.input?.source || this.yamlObj.entity_type?.const?.value || this.yamlObj.neighbor_type?.input?.source || this.yamlObj.neighbor_type?.const?.value || '';

					// Copy the base options passed from parent
					let opts = Array.from(this.entityTypeOptions);

					// Add the current value if it's not already in the options and is not empty
					if (currentValue && String(currentValue).trim() !== '') {
						const exists = opts.includes(currentValue);
						if (!exists) {
							// Prepend the missing value so the MultiSelect package can render it
							opts.unshift(currentValue);
						}
					}
					this.entityTypeFieldOptions = [...opts];
				}
			},

			// Collapse/Expand methods
			toggleCollapse(fieldName, index) {
				const key = `${fieldName}-${index}`;
				// Vue 3 compatible reactive update
				this.collapsedState[key] = !this.collapsedState[key];
				this.$forceUpdate(); // Force update if needed for reactivity
			},
			isCollapsed(fieldName, index) {
				const key = `${fieldName}-${index}`;
				return this.collapsedState[key] || false;
			},
			
			// Adds a new empty string to the invalid_values array
			addInvalidValue(field) {
				if (!this.yamlObj[field.name]['invalid_values']) {
					this.yamlObj[field.name]['invalid_values'] = [];
				}
				const currentList = [...this.yamlObj[field.name]['invalid_values']];
				currentList.push(""); // Add new blank entry
				this.update(field, 'invalid_values', currentList);
			},

			// Updates a specific index in the array
			updateInvalidValue(field, index, newValue) {
				const currentList = [...this.yamlObj[field.name]['invalid_values']];
				currentList[index] = newValue;
				this.update(field, 'invalid_values', currentList);
			},

			// Removes a specific index from the array
			removeInvalidValue(field, index) {
				const currentList = [...this.yamlObj[field.name]['invalid_values']];
				currentList.splice(index, 1);
				this.update(field, 'invalid_values', currentList);
			},
			addArrayItem(field) {
				if(!this.yamlObj[field.name])
					this.yamlObj[field.name] = [];
				
				this.yamlObj[field.name].push({});
				this.updateModelValue(this.yamlObj);
			},
			deleteArrayItem(field, index) {
				this.yamlObj[field.name].splice(index, 1);
				// Clean up collapse state - Vue 3 compatible
				const key = `${field.name}-${index}`;
				delete this.collapsedState[key];
				this.updateCollapsedState(field, index);
				this.$forceUpdate(); // Force update for reactivity
				this.updateModelValue(this.yamlObj);
			},
			updateCollapsedState(field, index) {
				let newCollapsedState = {};
				Object.keys(this.collapsedState).forEach(key => {
					if (key.startsWith(field.name)) {
						const keyIndex = Number(key.split('-')[1]);
						if (keyIndex > index) {
							console.log('keyIndex: ', keyIndex);
							newCollapsedState[`${field.name}-${keyIndex - 1}`] = this.collapsedState[key];
						} else {
							console.log('keyIndex: ', keyIndex);
							newCollapsedState[key] = this.collapsedState[key];
						}
					} else {
						console.log('key: ', key);
						newCollapsedState[key] = this.collapsedState[key];
					}
				});
				this.collapsedState = newCollapsedState;
			},
			updateMapKey(field, key, newKey) {
				let mapVal = this.yamlObj[field.name][key];
				this.yamlObj[field.name][newKey] = mapVal;

				delete this.yamlObj[field.name][key];

				this.updateModelValue(this.yamlObj);

			},
			updateInnerMapKey(field, key, innerKey) {
				const mapVal = this.yamlObj[field.name][key];
				const oldValue = mapVal.input?.source ?? mapVal.const?.value;
				const newValue = {
					[innerKey]: {
						[innerKey === 'const' ? 'value' : 'source']: oldValue
					}
				};
				this.yamlObj[field.name][key] = newValue;
				this.updateModelValue(this.yamlObj);
			},
			updateSelect(field, value) {
				let self = this;

				let keyValues = Object.entries(this.yamlObj[field.name]);

				if (value == "const") {
					keyValues.splice(1, 0, ["const", { value: '' }]);
					this.yamlObj[field.name] = Object.fromEntries(keyValues);
				} else if (value == "input") {
					keyValues.splice(1, 0, ["input", { source: null }]);
					this.yamlObj[field.name] = Object.fromEntries(keyValues);
				} else if (value == "list") {
					this.yamlObj[field.name][value] = {values: [""]};
				} else if (value == "compound") {
					this.yamlObj[field.name][value] = {};
				} else if (value == "map") {
					this.yamlObj[field.name][""] = {"const": {"value": ""}};
				}
                
				Array.isArray(field.type) && field.type.forEach((key) => {
					if (key !== value) {
						delete self.yamlObj[field.name][key];
					}
				});
				this.updateModelValue(this.yamlObj);
			},
			update(field, type, value) {
				let name = field.name;
				if (type == "const") {
					this.yamlObj[name]["const"] = { value: value };
				} else if (type == "input") {
					this.yamlObj[name]["input"] = { source: value };
				}
				else if (type == "invalid_values" || type == "map_value" || type == "list") {
					if (type == "invalid_values" && Array.isArray(value)) {
						// Directly set if already an array (from our new row methods)
						this.yamlObj[name][type] = value;
					} else {
						// Otherwise, validate and parse (for text-based JSON inputs like list/map_value)
						if (this.validateJSON(name, value)) {
							this.yamlObj[name][type] = (type == 'list' ? { values: JSON.parse(value) } : JSON.parse(value));
						} else {
							return;
						}
					}
				} else {
					this.yamlObj[name][type] = value;
				}

				this.updateModelValue(this.yamlObj);
				
			},
			updateModelValue(yamlObj) {
				if (this.parentObj) {
					let parentObj = this.parentObj;
					parentObj[this.parentField][this.parentIndex] = yamlObj;
					this.$emit("update:modelValue", parentObj);
				} else {
					this.$emit("update:modelValue", yamlObj);
				}
			},
			onUpdateParsedYaml(val) {
				this.updateModelValue(val);
			},
			fetchOptions(optionsArray) {
				let options = [];
				if (optionsArray && optionsArray.length) {
					optionsArray.map((option) => {
						options.push({ label: option, value: option });
					});
				}

				return options;
			},
			addNewProperty(field, index) {
				this.addNewPropFlagObj[`${field.name}-${index}`] = true;
			},
			getOptions(field) {
			//   If the type is const, invalid_values and map_value will not be supported in enterprise case. 
			//   In case of aut, map_values not supported for all the types and if the type is const, invalid_values is only supported only when wildcard is given('*').
				let aut_comparision_fields = ['entity_type', 'entity_domain', 'entity_id', 'neighbor_type', 'neighbor_domain', 'neighbor_id', 'owner', 'partner', 'property', 'id_type', 'id_format']
				const fieldName = field.name
				let fieldProps = this.yamlObj[fieldName]
					? Object.keys(this.yamlObj[fieldName])
					: [];

				const isGlobalConstValue = !fieldProps.includes("const") || this.yamlObj[fieldName]["const"]["value"]=="*"
				let mapKeys =
					fieldProps.length &&
					field.type.filter((key) => fieldProps.includes(key)||key=='map')
						.length
						? this.mapPropKeys.filter((key) => isValid(key))
						: field.type.concat(this.mapPropKeys).filter(key => !fieldProps.includes(key));
					
				
					function isValid(key) {
						if (fieldProps.includes(key)) return false;

						if (key === 'to_lower' || key === 'trim_space') {
							if (!aut_comparision_fields.includes(fieldName) && !isGlobalConstValue) {
								return false
							}
							return true
						} else if (key === 'invalid_values') {
							if (['entity_type', 'entity_domain'].includes(fieldName)) {
								if (fieldProps.includes('input')) {
									return true
								}
								return false
							} 
							if (fieldProps.includes('list')) {
								return false
							}
						}
						return isGlobalConstValue
					}
					
				
				
				if (fieldName !== "entity_id" && fieldName !== "neighbor_id") {
					mapKeys = mapKeys.filter(ele => ele != "validate")
				}
				
				mapKeys = mapKeys.filter(key => (key in field || field.type.includes(key)))
				return this.fetchOptions(mapKeys);
			},
			addProperty(field, value, index) {
				let name = field.name;
				//this.addNewPropFlagObj[`${name}-${index}`] = false;
				if (!this.yamlObj[name]) this.yamlObj[name] = {};

				if (field.type.includes(value)) {
					this.updateSelect(field, value);
				} else {
					if (value == "invalid_values") {
						if (this.invalidValues.length > 0) {
							this.yamlObj[name]["invalid_values"] = [...this.invalidValues];
						} else {
							this.yamlObj[name]["invalid_values"] = field.invalid_values ? [...field.invalid_values] : [""];
						}
					}
					else if (value == "to_lower")
						this.yamlObj[name]["to_lower"] = field.to_lower;
					else if (value == "trim_space")
						this.yamlObj[name]["trim_space"] = field.trim_space;
					else if (value == "validate")
						this.yamlObj[name]["validate"] = field.validate;
					else if (value == "map_value")
						this.yamlObj[name]["map_value"] = {};

					this.updateModelValue(this.yamlObj);
				}
			},

			deleteProperty(field, key) {
				if(!key || (field.type).includes(key) && field.optional) {

					// Optional properties deletion
					delete this.yamlObj[field.name]
				} else {
					delete this.yamlObj[field.name][key];
				}
				this.updateModelValue(this.yamlObj);
			},			
			removeLastS(str) {
				if (str.endsWith("s")) {
					return str.slice(0, -1);
				}
				return str;
			},
			validateJSON(name,value) {
				try {
					JSON.parse(value);									
				} catch(e) {
					this.errorObj[`${name}-${this.parentIndex}`] = "Invalid input!";
					return false;
				}
				this.errorObj[`${name}-${this.parentIndex}`] = null;
				return true;
			},			
			hasNestedKey(obj, key) {
				if (typeof obj !== 'object' || obj === null) {
					return false; 
				}

				if (key in obj) {
					return true; 
				}

				// Recursively check nested objects
				for (const nestedKey in obj) {
					if (this.hasNestedKey(obj[nestedKey], key)) {
						return true;
					}
				}

				return false; 
			}

		},
		emits: ["update:modelValue", "change"],
	};
</script>

<style scoped>
	.invisible {
		visibility: hidden;
	}

	.code-font {
		font-family: monospace;
		padding: 10px;
		white-space: pre;
		overflow: scroll;
		width: 300px;
	}

	.prop-btn {
		background-color: rgba(128, 128, 128, 0.25019607843);
		border-color: rgba(128, 128, 128, 0.25019607843);
	}

	.position-relative {
		position: relative;
	}

	/* COLLAPSIBLE BOX STYLING - MAIN FEATURE */
	
	.extract-container {
		background: linear-gradient(to right, #f1f3f5 0%, #f1f3f5 100%);
		border: 1px solid #000000;
		border-top: none;
		border-left: none;
		/* more shadow towards right */
		box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.08);
	}

	.extract-header {
		background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%) !important;
		color: white !important;
		border: none !important;
		font-weight: 600;
		letter-spacing: 0.5px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}

	.extract-footer {
		background: linear-gradient(135deg, #ececec 0%, #ffffff 100%);
		border: none;
		border-top: 2px solid #dee2e6;
		position: relative;
		border-bottom-left-radius: 8px; 
		overflow: hidden;
	}

	.extract-footer::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 1.9px; /* Match the thickness of your other vertical lines */
		height: 100%;
		/* Gradient starts from black (#000000) and ends at white (#ffffff) */
		background: linear-gradient(to bottom, #000000, #ced4da);
	}

	.collapsible-box {
		background: white;
		border-radius: 8px;
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
		overflow: hidden;
		transition: all 0.3s ease;
		border: 1.5px solid #ffffff;
		margin-left: 25.5px;
		margin-right: 10px;
		margin-bottom: 10px;
	}

	.collapsible-box-first {
		margin-top: 10px;
	}

	.collapsible-box:hover {
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
	}

	.collapsible-header {
		background: linear-gradient(-135deg, #0d6efd 0%, #0b5ed7 100%);
		padding: 0.4rem 0.5rem;
		padding-left: 1.25rem;
		cursor: pointer;
		display: flex;
		justify-content: space-between;
		align-items: center;
		transition: all 0.2s ease;
		user-select: none;
	}

	.collapsible-header:hover {
		background: linear-gradient(-135deg, #0b5ed7 0%, #0a58ca 100%);
	}

	.header-content {
		display: flex;
		align-items: center;
		gap: 0.75rem;
		color: white;
		font-weight: 600;
		font-size: 0.95rem;
	}

	.collapse-icon {
		transition: transform 0.3s ease;
		font-size: 0.85rem;
		color: white;
	}

	.item-title {
		letter-spacing: 0.3px;
	}

	.delete-btn {
		background: rgba(255, 255, 255, 0.2);
		border: 1px solid rgba(255, 255, 255, 0.3);
		color: white;
		padding: 0.3rem 0.65rem;
		font-size: 0.85rem;
		transition: all 0.2s ease;
		backdrop-filter: blur(10px);
	}

	.delete-btn:hover {
		background: rgba(239, 68, 68, 0.9);
		border-color: rgba(239, 68, 68, 1);
		color: white;
		transform: scale(1.05);
	}

	.collapsible-content {
		overflow: visible;
		transition: max-height 0.3s ease-in-out, opacity 0.2s ease;
		opacity: 1;
		transform: scaleY(1);
		transform-origin: top;
	}

	.collapsible-content.collapsed {
		opacity: 0;
		transform: scaleY(0);
		height: 0;
		overflow: hidden;
	}

	.content-inner {
		padding: 1.25rem;
		background: linear-gradient(to bottom, #fafbfc 0%, #ffffff 100%);
		overflow: visible;
		height: auto;
	}

	/* Ensure card body doesn't create scroll context */
	.card .card-body {
		overflow: visible;
		max-height: none;
		height: auto;
		border-right: 2px solid #ced4da;
	}

	/* Only code-font should have scroll, not array items */
	.code-font {
		overflow: auto;
		max-height: none;
	}

	/* Ensure card doesn't create scroll context */
	.card {
		overflow: visible;
		max-height: none;
		height: auto;
	}

	.card-header {
		border: 2px solid #ced4da;
		border-bottom: none;
		background-color: #ced4da;
	}

	.card-footer {
		border: none;
	}

	.input-group-text {
		background-color: #f8f9fa;
	}

	.input-group-text2 {
		background-color: #fff;
	}

	/* Decorative Add Buttons */
	.btn-secondary {
		background: linear-gradient(135deg, #0d6efd 0%, #0b5ed7 100%);
		border: none;
		color: #fff;
		font-weight: 600;
		padding: 0.5rem 1rem;
		border-radius: 4px;
		box-shadow: 0 2px 4px rgba(13, 110, 253, 0.3);
		transition: all 0.2s ease-in-out;
		display: inline-flex;
		align-items: center;
		gap: 0.5rem;
	}

	.btn-secondary:hover {
		background: linear-gradient(135deg, #0b5ed7 0%, #0a58ca 100%);
		box-shadow: 0 4px 8px rgba(13, 110, 253, 0.4);
		color: #fff;
	}

	.btn-secondary:active {
		transform: translateY(0);
		box-shadow: 0 2px 4px rgba(13, 110, 253, 0.3);
	}

	.btn-secondary i {
		font-size: 0.875rem;
	}

	/* Decorative Delete Buttons */
	.btn.prop-btn {
		background: rgb(230, 55, 87);
		border: none;
		color: #fff;
		font-weight: 600;
		border-radius: 3px;
		min-width: 25px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
	}

	.btn.prop-btn:hover {
		background: rgb(212, 51, 80);
		color: #fff;
	}

	.btn.prop-btn:active {
		box-shadow: 0 2px 4px rgba(220, 53, 69, 0.3);
	}

	.btn.prop-btn strong {
		font-size: 1.1rem;
		line-height: 1;
	}

	/* Uniform Dropdown Styling */
	.btn-group {
		position: relative;
	}

	.btn-group .dropdown-toggle {
		background-color: #6e84a3;
		border: none;
		color: #fff;
		font-weight: 600;
		border-radius: 4px;
		transition: all 0.2s ease-in-out;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		min-width: 40px;
		height: 30px;
	}

	.btn-group .dropdown-toggle:hover {
		background-color: #5f718b;
	}

	.btn-group .dropdown-toggle::after {
		margin-left: 0.5rem;
		vertical-align: middle;
		border-top-color: #fff;
	}

	/* Uniform Dropdown Menu */
	.dropdown-menu {
		border: 1px solid #f0f0f0;
		border-radius: 4px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		background-color: #fff;
		min-width: 180px;
		position: absolute;
	}

	.dropdown-menu li {
		list-style: none;
	}

	.dropdown-item {
		color: #707070;
		font-weight: 400;
		transition: all 0.15s ease-in-out;
		border: none;
		background: none;
		width: 100%;
		text-align: left;
		cursor: pointer;
		display: block;
		text-decoration: none;
		padding: 0.175rem 1.175rem;
	}

	.dropdown-item:hover {
		background: #e2e2e2;
		color: #000000;
	}

	.dropdown-item:active {
		background: #e2e2e2;
		color: #000000;
	}

	/* Uniform Select Dropdown (for property selection) */
	.form-select.prop-btn {
		background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);
		border: none;
		color: #fff;
		font-weight: 600;
		padding: 0.5rem 1rem;
		border-radius: 6px;
		box-shadow: 0 2px 4px rgba(108, 117, 125, 0.3);
		transition: all 0.2s ease-in-out;
		cursor: pointer;
	}

	.form-select.prop-btn:hover {
		background: linear-gradient(135deg, #5a6268 0%, #545b62 100%);
		transform: translateY(-2px);
		box-shadow: 0 4px 8px rgba(108, 117, 125, 0.4);
		color: #fff;
	}

	.form-select.prop-btn:focus {
		background: linear-gradient(135deg, #5a6268 0%, #545b62 100%);
		border: none;
		box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.25);
		color: #fff;
	}

	.form-select.prop-btn option {
		background-color: #fff;
		color: #495057;
		padding: 0.5rem;
	}

	.row[style*="background-color: rgb(237, 242, 249)"] {
		background: linear-gradient(135deg, #f8f9fa, #e9ecef) !important;
		border-bottom: 2px solid #dee2e6;
	}

	.row[style*="background-color: white"] {
		background-color: #fafbfc !important;
	}

	.row[style*="border"]:hover {
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
	}

	/* Styles for sub array items like invalid values */
	.sub-array-item .btn-link {
		color: gray;
	}

	.card .sub-array-item {
		position: relative;
		overflow: visible;
	}

	.card .sub-array-item.card-body :not(:first-child) {
		margin-top: 2em;
	}

	.sub-array-item-first .btn-link {
		color: gray;
	}

	.card .sub-array-item-first {
		position: relative;
		overflow: visible;
	}

	.card .sub-array-item-first.card-body :not(:first-child) {
		margin-top: 2em;
	}

	/* Ensure array item body doesn't create scroll context */
	.sub-array-item-body {
		overflow: visible !important;
		max-height: none !important;
		height: auto !important;
	}
	
	/* Ensure array item body doesn't create scroll context */
	.sub-array-item-body-first {
		overflow: visible !important;
		max-height: none !important;
		height: auto !important;
	}

	.card .sub-array-item::before {
		position: absolute;
		left: 0px;
		top: 1.5px;
		border-left: 2px solid var(--bs-dark, #000000);
		border-bottom: 2px solid var(--bs-dark, #000000);
		content: "";
		width: 15px;
		height: 1em;
	}

	.card .sub-array-item::after {
		position: absolute;
		left: -0px;
		bottom: 0px;
		border-left: 2px solid var(--bs-dark, #000000);
		content: "";
		width: 8px;
		height: 100%;
	}

	.card .sub-array-item-first::before {
		position: absolute;
		left: 0px;
		top: 7.5px;
		border-left: 2px solid var(--bs-dark, #000000);
		border-bottom: 2px solid var(--bs-dark, #000000);
		content: "";
		width: 15px;
		height: 1em;
	}

	.card .sub-array-item-first::after {
		position: absolute;
		left: -0px;
		bottom: 0px;
		border-left: 2px solid var(--bs-dark, #000000);
		content: "";
		width: 8px;
		height: 100%;
	}

	.card .sub-array-item-body::after {
		position: absolute;
		left: 13px;
		top: 5.5px;
		content: "\25B6";
		color: var(--bs-dark, #000000);
		width: 8px;
		height: 1em;
	}

	.card .sub-array-item-body-first::after {
		position: absolute;
		left: 13px;
		top: 11.5px;
		content: "\25B6";
		color: var(--bs-dark, #000000);
		width: 8px;
		height: 1em;
	}

	.sub-card-footer {
		position: relative;
		border: 2px solid #dee2e6;
		border-top: none;
		border-left: none;
		border-radius: 0 0 0.2rem 0.2rem;
		padding: 0.5rem;
	}

	/* The Gradient Left Border */
	.sub-card-footer::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 2px;
		height: 100%;
		background: linear-gradient(to bottom, #000000, #dee2e6);
		border-radius: 0 0 0 0.2rem; 
	}

	.array-item .btn-link {
		color: gray;
	}

	.card .array-item {
		position: relative;
		overflow: visible;
		background: linear-gradient(-135deg, #ffffff, #ececec);
	}

	.card .array-item.card-body :not(:first-child) {
		margin-top: 2em;
	}

	.array-item-first .btn-link {
		color: gray;
	}

	.card .array-item-first {
		position: relative;
		overflow: visible;
	}

	.card .array-item-first.card-body :not(:first-child) {
		margin-top: 2em;
	}

	/* Ensure array item body doesn't create scroll context */
	.array-item-body {
		overflow: visible !important;
		max-height: none !important;
		height: auto !important;
	}
	
	/* Ensure array item body doesn't create scroll context */
	.array-item-body-first {
		overflow: visible !important;
		max-height: none !important;
		height: auto !important;
	}

	.card .array-item::before {
		position: absolute;
		left: 0px;
		top: 11px;
		border-left: 2px solid var(--bs-dark, #000000);
		border-bottom: 2px solid var(--bs-dark, #000000);
		content: "";
		width: 15px;
		height: 1em;
	}

	.card .array-item::after {
		position: absolute;
		left: -0px;
		bottom: 0px;
		border-left: 2px solid var(--bs-dark, #000000);
		content: "";
		width: 8px;
		height: 100%;
	}

	.card .array-item-first::before {
		position: absolute;
		left: 0px;
		top: 20px;
		border-left: 2px solid var(--bs-dark, #000000);
		border-bottom: 2px solid var(--bs-dark, #000000);
		content: "";
		width: 15px;
		height: 1em;
	}

	.card .array-item-first::after {
		position: absolute;
		left: -0px;
		bottom: 0px;
		border-left: 2px solid var(--bs-dark, #000000);
		content: "";
		width: 8px;
		height: 100%;
	}

	.card .array-item-body::after {
		position: absolute;
		left: 13px;
		top: 15px;
		content: "\25B6";
		color: var(--bs-dark, #000000);
		width: 8px;
		height: 1em;
	}

	.card .array-item-body-first::after {
		position: absolute;
		left: 13px;
		top: 24px;
		content: "\25B6";
		color: var(--bs-dark, #000000);
		width: 8px;
		height: 1em;
	}

	.no-data {
		margin-top: 2px;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #6c757d;
		font-size: 0.875rem;
		font-weight: 400;
	}

	.form-control:disabled {
		background-color: #ffffff;
	}
	.form-group {
		margin-bottom: 0rem;
	}
	::v-deep(.multiselect) {
		border-top-left-radius: 0px;
		border-bottom-left-radius: 0px;
	}
</style>

<style lang="scss">
@use '../theme/scss/_user-variables.scss' as *;

body.dark-mode {
    // Background overrides for row containers
    .row[style*="background-color: rgb(237, 242, 249)"] {
        background: linear-gradient(135deg, $dark-elevated-bg, $dark-border-color) !important;
        border-bottom: 2px solid $dark-border-color;
    }

    .row[style*="background-color: white"] {
        background-color: $dark-elevated-bg !important;
    }

    // 1. Array and Sub-Array Item Connectors (The Lines)
    .card .array-item, 
    .card .array-item-first, 
    .card .sub-array-item, 
    .card .sub-array-item-first {
        background: linear-gradient(to left, $dark-border-color, $dark-border-color) !important;

        &::before, &::after {
            border-color: $dark-text-secondary !important; // Overriding the hardcoded #000000
        }
    }

    // 2. The Pointer Arrows (The Triangle Icon)
    .card .array-item-body, 
    .card .array-item-body-first, 
    .card .sub-array-item-body, 
    .card .sub-array-item-body-first {
        &::after {
            color: $dark-text-secondary !important; // Changes the \25B6 arrow color
        }
    }

    // 3. Footer and Sub-Card Footer Vertical Gradient Lines
    .extract-footer, 
    .sub-card-footer {
        background: linear-gradient(to left, $dark-elevated-bg, $dark-border-color) !important;
        border-color: $dark-border-color !important;

        &::before {
            // Gradient now transitions from your custom border color to the theme border color
            background: linear-gradient(to bottom, $dark-text-secondary, $dark-border-color) !important;
        }
    }

    // Optional: Ensure text like "No data found" is readable
    .no-data {
        color: $dark-text-secondary !important;
    }

    .dark-mode-invalid-values {
        background-color: $dark-elevated-bg !important;
    }

	/* 1. Collapsible Content Background */
    .collapsible-content {
        background-color: $dark-elevated-bg !important;
    }

	.collapsible-box {
		border-color: $dark-border-color !important;
	}

    .content-inner {
        // Overriding the light-mode linear-gradient (#fafbfc to #ffffff)
        background: linear-gradient(to bottom, $dark-elevated-bg 0%, $dark-card-bg 100%) !important;
        border-color: $dark-border-color !important;
        color: $dark-text-primary !important;
    }

}
</style>